import { useEffect } from 'react';

import { useData, useInitialize } from '@kameleoon/react-sdk';

const useConversionTracking = (
    applicationEmail: string | null,
    goalId: number,
) => {
    const { isInitialized } = useInitialize();
    const { trackConversion } = useData();

    useEffect(() => {
        if (applicationEmail && isInitialized()) {
            trackConversion({
                visitorCode: applicationEmail,
                goalId,
            });
        }
    }, [applicationEmail, trackConversion, isInitialized, goalId]);
};

export default useConversionTracking;
